import { extendTheme } from "@chakra-ui/react";
import { BUTTON_THEME } from "./components/button";
import { CHECKBOX_THEME } from "./components/checkbox";
import { FORM_THEME } from "./components/form";
import { TEXT_THEME } from "./components/text";

const theme = extendTheme({
  colors: {
    brandPrimary: {
      50: "#F7F7FB",
      100: "#DFDFF0",
      200: "#C3C3E3",
      300: "#A1A1D3",
      400: "#8F8FCB",
      500: "#6060B5",
      600: "#4D4D91",
      700: "#40417B",
      800: "#353666",
      900: "#2F2F59",
    },
    brandSecondary: {
      50: "#F7F7FB",
      100: "#DEE0E6",
      200: "#C3C5CD",
      300: "#A1A5B7",
      400: "#9094A2",
      500: "#787C8E",
      600: "#64697D",
      700: "#505464",
      800: "#434754",
      900: "#31333D",
    },
  },
  shadows: {
    outline: "0 0 0 3px var(--chakra-colors-brandPrimary-500)",
  },
  components: {
    Button: BUTTON_THEME,
    Checkbox: CHECKBOX_THEME,
    Text: TEXT_THEME,
    Form: FORM_THEME,
  },
  styles: {
    global: {
      body: {
        overflowY: "scroll",
        fontFamily: "'Lato'",
      },
      ".renderer h1": {
        fontFamily: "'Playfair Display'",
        fontSize: { base: "1.875rem", xl: "2.5rem" },
        fontWeight: 400,
        lineHeight: "normal",
        color: "brandPrimary.900",
      },
      ".renderer h2": {
        fontFamily: "'Lato'",
        fontSize: { base: "1.5rem", xl: "2.125rem" },
        fontWeight: 300,
        lineHeight: "normal",
      },
      ".renderer h3": {
        fontFamily: "'Playfair Display'",
        fontSize: { base: "1.375rem", xl: "2rem" },
        fontWeight: 300,
        lineHeight: "normal",
        color: "brandPrimary.900",
      },
      ".renderer h4": {
        fontFamily: "'Lato'",
        fontSize: { base: "1.25rem", xl: "1.5rem" },
        fontWeight: 300,
        lineHeight: "normal",
        color: "brandSecondary.600",
      },
      ".renderer p, .renderer .paragraph, .renderer ul": {
        fontSize: "1.125rem",
        fontWeight: 400,
        lineHeight: "1.3125rem",
        color: "#3D557B",
        mt: "0.875rem",
        ":first-child": {
          mt: 0,
        },
      },
      ".renderer ul": {
        marginLeft: "1.5rem",
      },
    },
  },
});

export default theme;
